import { bundledQuran as quran, type SurahMeta } from './source';
import { foldSurahName } from './arabic';

/**
 * Matches on the Arabic name, the transliteration, or the number.
 *
 * The Arabic side is matched FOLDED. The stored name is سُورَةُ الكَهۡفِ — the
 * word سورة plus full Quranic diacritics — and a reader types الكهف, so a raw
 * includes() finds nothing at all. Nobody types harakat into a search box.
 *
 * The number matters more than it looks: people say "sūrah 36" as readily as
 * "Yā-Sīn", and a معلم hunting for it in a 114-row list mid-session is the
 * thing this search exists to avoid.
 */
export function filterSurahs(term: string): SurahMeta[] {
  const raw = term.trim();
  const needle = raw.toLowerCase();
  const folded = foldSurahName(raw);
  const all = quran.surahs();
  if (!raw) return all;
  return all.filter((s) =>
    (folded.length > 0 && foldSurahName(s.name).includes(folded))
    || s.englishName.toLowerCase().includes(needle)
    || String(s.n).startsWith(needle));
}
